import { Controller } from "@hotwired/stimulus";
import { Swiper } from "swiper";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

// Connects to data-controller="swiper"
export default class extends Controller {
  static targets = ["container", "prevButton", "nextButton", "pagination"];
  static classes = ["navigationDisabled", "paginationActive"];
  static values = {
    autoplayDelay: Number,
  };

  connect() {
    this.swiper = new Swiper(this.containerTarget, {
      modules: [Navigation, Pagination, Autoplay],
      slidesPerView: 1,
      spaceBetween: 20,
      autoplay: {
        delay: this.autoplayDelayValue,
      },
      pagination: {
        el: this.hasPaginationTarget ? this.paginationTarget : undefined,
        clickable: true,
        bulletActiveClass: this.paginationActiveClasses.join(" ") || "swiper-pagination-bullet-active",
      },
      navigation: {
        nextEl: this.hasNextButtonTarget ? this.nextButtonTarget : undefined,
        prevEl: this.hasPrevButtonTarget ? this.prevButtonTarget : undefined,
        disabledClass: this.navigationDisabledClasses.join(" ") || "swiper-button-disabled",
      },
    });
  }

  disconnect() {
    if (this.swiper) {
      this.swiper.destroy();
    }
  }
}
